import { render, staticRenderFns } from "./issue-config.vue?vue&type=template&id=439674ac"
import script from "./issue-config.vue?vue&type=script&lang=js"
export * from "./issue-config.vue?vue&type=script&lang=js"
import style0 from "./issue-config.vue?vue&type=style&index=0&id=439674ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports